import React from 'react'

const CompanyDetails = () => {
    return (
        <div>
            <div className='flex items-center'>
                <img src={require('assets/img/profile.png')} alt='user' className='w-24' />
                <div className='ml-4'>
                    <p className='text-dark font-medium text-2xl'>Administrator</p>
                    <p className='text-dark opacity-50 text-lg'>Super admin</p>
                </div>
            </div>

            <div className='mt-6'>
                <p className='font-medium text-xl text-dark'>General information</p>
            </div>

            <div className='lg:w-9/12 grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-8 mt-5 mb-10'>
                <div>
                    <input
                        type='text'
                        placeholder='Company name'
                        className='py-3 rounded-midxs placeholder-dark-100-light w-full text-sm'
                    />
                </div>
                <div>
                    <input
                        type='email'
                        placeholder='Email address'
                        className='py-3 rounded-midxs placeholder-dark-100-light w-full text-sm'
                    />
                </div>
                <div>
                    <input
                        type='text'
                        placeholder='Location'
                        className='py-3 rounded-midxs placeholder-dark-100-light w-full text-sm'
                    />
                </div>
                <div>
                    <input
                        type='number'
                        placeholder='RC number'
                        className='py-3 rounded-midxs placeholder-dark-100-light w-full text-sm'
                    />
                </div>
                <div>
                  <button className="w-full py-4 rounded-xs text-white bg-green font-medium mt-3">Update profile</button>
                </div>
            </div>
        </div>
    )
}

export default CompanyDetails
